import { render, staticRenderFns } from "./instashop.vue?vue&type=template&id=02f89bac&"
import script from "./instashop.vue?vue&type=script&lang=js&"
export * from "./instashop.vue?vue&type=script&lang=js&"
import style0 from "./instashop.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/opt/build/repo/storefront/components/molecules/Row/Heading.vue').default,BaseRow: require('/opt/build/repo/storefront/components/atoms/Layout/BaseRow.vue').default,InstagramGrid: require('/opt/build/repo/storefront/components/molecules/Instagram/InstagramGrid.vue').default,BaseLayout: require('/opt/build/repo/storefront/components/atoms/Layout/BaseLayout.vue').default})
